import { Logger, Storage } from 'aws-amplify';

import * as moment from 'moment';
/**
 * Logger.
 * Loggerインスタンスを保持し、アプリケーション共有のLoggerとする。
 * @return {Logger} loggerのインスタンス。
 * see: https://aws-amplify.github.io/docs/js/logger
 */
let logger: Logger;
Logger.LOG_LEVEL = process.env.REACT_APP_LOG_LEVEL;
export const getLogger = (): Logger => {
  if (!logger) {
    logger = new Logger('aiapp');
  }
  return logger;
};

/**
 * 日付をM/Dでフォーマットする。時刻が00:00:00じゃない場合はそれも付与する
 * @param dateStr 日付文字列(YYYY-MM-DDTHH:mm:SSZ
 */
export const simpleDateFormat = (dateStr: string): string => {
  return moment(dateStr).format('M/D HH:mm').replace(/ 00:00$/,'');
};

/**
 * 数値の合計値を求める
 */
export const sum = (src: number[]): number => {
  if (!src || src.length === 0) {
    return 0;
  }
  let result = 0;
  src.forEach(num => (result += num));
  return result;
};

/**
 *  平均値を導出する
 */
export const average = (src: number[]): number => {
  if (!src || src.length === 0) {
    return 0;
  }
  return sum(src) / src.length;
};

/**
 * 四捨五入する
 * @param src {number} 元の数値
 * @param pos {number} 小数点以下何位までを有効にするか。2を指定すると小数点以下第3位で四捨五入する
 */
export const round = (src: number, pos = 0): number =>
  Math.round(src * Math.pow(10, pos)) / Math.pow(10, pos);

/**
 * 文字列を数値にして四捨五入する。数値として扱えない文字または空文字の場合はもとの文字列をそのまま返す
 * @param src {string} 元の数値
 * @param pos {number} 小数点以下何位までを有効にするか。2を指定すると小数点以下第3位で四捨五入する
 */
export const roundStr = (src: string, pos = 0): string => {
  // 空文字、数値に変換できない場合は何もしないで返す
  if (!src || !Number(src)) {
    return src;
  }
  const num = Number(src);
  return '' + Math.round(num * Math.pow(10, pos)) / Math.pow(10, pos);
};

/**
 * 文字列を数値にして切り捨てする。数値として扱えない文字または空文字の場合はもとの文字列をそのまま返す
 * @param src {string} 元の数値
 * @param pos {number} 小数点以下何位までを有効にするか。2を指定すると小数点以下第3位で切り捨てする
 */
export const floorStr = (src: string, pos = 0): string => {
  // 空文字、数値に変換できない場合は何もしないで返す
  if (!src || !Number(src)) {
    return src;
  }
  const num = Number(src);
  return '' + Math.floor(num * Math.pow(10, pos)) / Math.pow(10, pos);
};

/**
 * CSVファイルをダウンロードする。データにはBOMを付与する。
 * @param {string[][]} csvRecords データ
 * @param {string} filename
 */
export const downloadCsv = (csvRecords: string[][], filename: string): void => {
  // 行内の各列の値をダブルクォートでくくってカンマで結合する
  // 行の値を改行で結合する
  const content = csvRecords.map(rec =>
    rec.map(r => `"${r}"`).join(',')
  ).join('\n');

  const downLoadLink = document.createElement("a");
  downLoadLink.download = filename;
  const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
  downLoadLink.href = URL.createObjectURL(new Blob([bom, content], {type: "text/csv"}));
  downLoadLink.dataset.downloadurl = ["text/plain", downLoadLink.download, downLoadLink.href].join(":");
  downLoadLink.click();
};

  /*
   *  アーカイブファイルをダウンロードする
   */
export const download = async (bucket: string, fileKey: string) => {
  console.log('Start downloading', bucket, fileKey);
  // downloadオプションをつけずにSignedURLを得る
  // downloadオプションをつけるとBodyにファイルが入ってくるが、
  // a.href に設定するとサイズ制限（文字列長制限）で切られる。
  const result = await Storage.vault.get(fileKey, {
    // download: true,
    bucket,
    level: 'public',
    customPrefix: {
      public: ''
    }
  });
  // a タグを生成してClickすることでダウンロードさせる
  const url = result as string;
  const link = document.createElement('a');
  link.href = url;
  // ダウンロード時の保存ファイル名
  // prefixがついている場合"/" -> "_"に置き換えられるが、この挙動はブラウザに依存する。
  link.download = fileKey;
  link.click();
  console.log('Finish downloading');
}



// WEBPACK FOOTER //
// ./src/utils/index.ts